<template>
  <v-container>
    <BaseList
      flat
      color="primary"
      :title="$t('transfer_index_title')"
      :section="$route.meta.section"
      :headers="headers"
      :items="instructions"
      :loading="loading"
      :totalRows="totalRows"
      :breadcrumbs="false"
      :elevation="0"
      :height="'100%'"
      :buttons="{ search: true, add: isAccountCode && canCreate }"
      @add="handleNew"
      @edit="handleEdit"
      @refresh="getData"
      @delete="handleDelete"
      @options="handleOptions"
      @search="handleSearch"
      :search="search"
    >
      <template #header.alias>
        <span> {{ $t('transfer_index_alias') }} </span>
      </template>
      <template #header.trType>
        <span> {{ $t('transfer_index_type') }} </span>
      </template>
      <template #header.bnfBankName>
        <span> {{ $t('transfer_index_bank') }} </span>
      </template>
      <template #header.status>
        <span> {{ $t('transfer_index_status') }} </span>
      </template>
      <template #header.bnfBankAccNumber>
        <span> {{ $t('transfer_index_account') }} </span>
      </template>
      <template #header.operation>
        <span> {{ $t('transfer_index_action') }} </span>
      </template>
      <template #item.isThirdParty="{ value }">
        <v-chip
          small
          :color="value ? 'primary' : 'default'"
          class="text-capitalize px-5"
        >
          {{ value ? $t('btn_yes') : $t('btn_no') }}
        </v-chip>
      </template>
      <template #item.operation="{ item }">
        <span class="d-flex justify-center gap" v-if="item.isCertified">
          <template
            v-if="(item.isThirdParty && !isExecutive) || !item.isThirdParty"
          >
            <v-btn
              color="red"
              outlined
              class="btn-action"
              text
              small
              v-can="'create-funds-withdrawal-request'"
              v-if="isAccountCode"
              @click="handleRetire(item)"
            >
              {{ $t('btn_withdraw') }}
            </v-btn>
            <!--
            <v-btn
              color="success"
              outlined
              class="btn-action"
              text
              x-small
              v-can="'create-notification-funds-deposits'"
              v-if="!handleAuthorityAccounts()"
              @click="handleDeposit(item)"
            >
              {{ $t('btn_deposit') }}
            </v-btn>
            -->
          </template>
        </span>
        <span v-else>
          <v-btn
            color="info"
            rounded
            outlined
            class="btn-action"
            text
            x-small
            v-can="'certify-permanent-instructions'"
            v-if="isAccountCode && !isExecutive"
            @click="handleValidationModal(item)"
          >
            {{ $t('btn_pending_certify') }}
          </v-btn>
        </span>
      </template>
      <template #item.bnfBankName="{ item }">
        <span>{{
          item.accountType == 'nfiAccount' ? item.nfiName : item.bnfBankName
        }}</span>
      </template>
      <template #item.status="{ item }">
        <span>{{ item.isCertified ? 'Certificada' : 'Debe Certificar'}}</span>
      </template>
      <template #item.bnfBankAccNumber="{ item }">
        <span>{{
          item.accountType == 'nfiAccount'
            ? handleBankAccount(item.nfiAccountNumber, item.isCertified)
            : handleBankAccount(item.bnfBankAccNumber, item.isCertified)
        }}</span>
      </template>
    </BaseList>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import BaseList from '@/components/commons/BaseList'
import ClientTransferInstructionsService from '@/services/clientTransferInstructions'
import CertifyModal from './partials/CertifyModal.vue'
import TwoFactorModal from '@/components/commons/TwoFactorModal.vue'
import { hasPermission } from '@/utils'

export default {
  components: { BaseList },
  data() {
    return {
      options: {},
      dialog: false,
      loading: false,
      totalRows: 0,
      instructions: [],
      certification: {},
      search: ''
    }
  },
  async created() {
    await this.getData()
  },
  computed: {
    ...mapState('account', ['account', 'authorityAccounts', 'accountData']),
    ...mapState('setting', ['settings']),
    ...mapState('auth', ['user']),

    headers() {
      if (this.isAccountCode) {
        return [
          {
            text: 'Alias',
            value: 'alias',
            width: '15rem'
          },
          {
            text: 'Tipo de Instrucción',
            value: 'trType',
            width: '4rem'
          },
          {
            text: 'Institución Financiera',
            value: 'bnfBankName',
            width: '15rem'
          },
          {
            text: 'beneficiary',
            value: 'beneficiary',
            width: '100%'
          },
          {
            text: 'payments_to_third_parties',
            value: 'isThirdParty',
            width: '6rem',
            align: 'center'
          },
          {
            text: 'Status',
            value: 'status',
            width: '15rem',
            align: 'center'
          },
          {
            text: 'Número de Cuenta',
            value: 'bnfBankAccNumber',
            align: 'center',
            width: '15rem'
          },
          {
            text: 'Operar',
            value: 'operation',
            align: 'center'
          }
        ]
      } else {
        return [
          {
            text: 'Alias',
            value: 'alias'
          },
          {
            text: 'Tipo de Instrucción',
            value: 'trType',
            width: '3rem'
          },
          {
            text: 'Institución Financiera',
            value: 'bnfBankName',
            width: '11rem'
          },
          {
            text: 'beneficiary',
            value: 'beneficiary',
            width: '11rem'
          },
          {
            text: 'payments_to_third_parties',
            value: 'isThirdParty',
            width: '5rem',
            align: 'center'
          },
          {
            text: 'Status',
            value: 'status'
          },
          {
            text: 'Número de Cuenta',
            value: 'bnfBankAccNumber',
            align: 'center'
          }
        ]
      }
    },

    isExecutive() {
      return (
        (this.user?.authorityLevelsCode === 1 ||
          this.user?.authorityLevelsCode === 2 ||
          this.user?.authorityLevelsCode === 4) &&
        !this.isAccountCode
      )
    },
    accountCode() {
      const item = this.user?.avobjects?.find(item => item.typeCode === 'accountCode')
      return item?.code || null
    },
    canCreate() {
      return this.hasPermission('create-third-party-permanent-instructions') ||
        this.hasPermission('create-permanent-instructions')
    },
    isAccountCode() {
      return (
        this.user?.avobjects?.findIndex(
          item =>
            item.code === this.account.code && item.typeCode === 'accountCode'
        ) > -1
      )
    }
  },
  methods: {
    ...mapActions('transfer', ['setPermanentInstruction']),
    async getData() {
      this.loading = true
      try {
        let data = await ClientTransferInstructionsService.find(
          this.account.code
        )
        this.instructions = data
        this.totalRows = data.length
      } catch (error) {
        if (error.response.status !== 401)
          this.$dialog.message.error('No se pudo cargar la información.')
      } finally {
        this.loading = false
      }
    },
    handleOptions(options) {
      this.options = options
      this.getData()
    },
    handleNew() {
      this.$router.push({ name: 'PermanentInstructionsCreate' })
    },
    handleEdit(item) {
      this.$router.push({ name: 'RegisterAccounts', params: { id: item.id } })
    },
    handleRetire(item) {
      item.fromIndex = true
      this.setPermanentInstruction(item)
      this.$router.push({ name: 'RetireCreate' })
    },
    handleDeposit(item) {
      item.fromIndex = true
      this.setPermanentInstruction(item)
      this.$router.push({ name: 'DepositCreate' })
    },
    // eslint-disable-next-line no-unused-vars
    async handleDelete(item) {
      const res = await this.$dialog.warning({
        text: '¿ Desea eliminar el registro ?',
        showClose: false
      })

      if (!res) return false

      try {
        /*
        await DisplayPeriodService.delete(item.id)
        */
        this.$dialog.notify.success('Registro eliminado con éxito.')
        await this.getData()
      } catch (e) {
        this.$dialog.message.error(e.title)
      }
    },
    handleBankAccount(acc, isCertified) {
      let account = isCertified ? acc : `...${acc.substring(acc.length - 4)}`
      return account
    },
    async handleCertifyModal(item) {
      const params = {
        fullscreen: this.$vuetify.breakpoint.smAndDown,
        width: '40%',
        transition: 'dialog-top-transition',
        transferInstructionId: item.transferInstructionId,
        bnfBankAccountNumber:
          item.accountType == 'nfiAccount'
            ? item.nfiAccountNumber
            : item.bnfBankAccNumber,
        showClose: false
      }

      const certify = await this.$dialog.showAndWait(CertifyModal, params)
      if (certify) this.getData()
    },
    handleSearch(search) {
      this.search = search
    },
    async handleValidationModal(item) {
      let twoFactorDeposit = this.settings.find(
        item => item.key === '2fa_deposit_notifications'
      )
      let twoFactorTransfer = this.settings.find(
        item => item.key === '2fa_transfer_requests'
      )
      let certifyModal
      if (twoFactorDeposit.value || twoFactorTransfer.value) {
        certifyModal = await this.handleTwoFactorModal(
          this.user.twofactor_habilitated
        )
      }

      if (!certifyModal) {
        this.$dialog.message.error(this.$t('twofactor_required'))
      } else if (certifyModal === 'reset') {
        this.$router.push({
          name: 'Delete',
          query: {
            redirect: 'instrucciones-permanentes'
          }
        })
      } else if (certifyModal) {
        await this.handleCertifyModal(item)
      }
    },
    async handleTwoFactorModal(twofactor) {
      const params = {
        fullscreen: this.$vuetify.breakpoint.smAndDown,
        width: twofactor ? '40%' : '80%',
        transition: 'dialog-top-transition',
        persistent: false,
        hideOverlay: false,
        twoFactor: twofactor,
        hideSubmit: true,
        showClose: twofactor
      }
      return await this.$dialog.showAndWait(TwoFactorModal, params)
    },
    hasPermission(permission) {
      return hasPermission(this.user, permission)
    },
  }
}
</script>

<style lang="sass" scoped>
.gap
  gap: 1rem

.btn-action
  min-width: 140px !important
</style>
